import React, { Fragment } from 'react';
import SEO from '../../components/SEO/SEO';
import NavbarS2 from '../../components/NavbarS2/NavbarS2';
import PageTitle from '../../components/pagetitle/PageTitle'
import About from '../../components/about/about';
import FunFact from '../../components/FunFact/FunFact';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.svg';
import { useLanguage } from '../../context/LanguageContext';

const AboutPage = () => {
    const { t } = useLanguage();

    return (
        <Fragment>
            <SEO title={t('pages.about')} />
            <NavbarS2 hclass={'wpo-site-header wpo-site-header-s2'} Logo={Logo} />
            <PageTitle pageTitle={t('pages.about')} pagesub={t('pages.about')} bgImage={'/banner/hakkimizda.jpg'} />
            <About hclass={'about-section section-padding'} />
            <FunFact hclass={'funfact-section'} />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default AboutPage;
